module.exports = __webpack_public_path__ + "img/c17d6b2.jpg";